export const getStorageStoreCode = () => {
  return sessionStorage.getItem('store_code');
};

export const updateStorageStoreCode = (code: string) => {
  sessionStorage.setItem('store_code', code);
};

export const removeStorageStoreCode = () => {
  sessionStorage.removeItem('store_code');
};

export const getShortStoreName = (storeCode: string, storeName: string) => {
  return storeCode + ' ' + storeName.slice(0, 3) + (storeName.length > 3 ? '...' : '');
};
